import React from 'react';

export default function AwsIcon({ title = 'AWS', size = 18 }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 64 64"
      role="img"
      aria-label={title}
      focusable="false"
    >
      <rect x="4" y="8" width="56" height="48" rx="10" fill="currentColor" opacity="0.12" />
      <path
        d="M20 40.5l4.6-13h4.3l4.7 13h-3.7l-.8-2.5h-4.8l-.8 2.5H20zm9.2-5.3l-1.5-4.6-1.5 4.6h3z"
        fill="currentColor"
      />
      <path
        d="M36.2 40.5v-13h3.4l4.7 7.8v-7.8H48v13h-3.3L40 32.6v7.9h-3.8z"
        fill="currentColor"
      />
      <path
        d="M16.5 46.8c8.2 5.3 22.1 5.3 31.1 0"
        stroke="currentColor"
        strokeWidth="2.6"
        strokeLinecap="round"
        opacity="0.9"
      />
      <path
        d="M47.8 46.8l-2.8.3 1.9-2.1"
        stroke="currentColor"
        strokeWidth="2.6"
        strokeLinecap="round"
        strokeLinejoin="round"
        opacity="0.9"
      />
    </svg>
  );
}

